export default __webpack_public_path__ + "static/media/mso_icon1.e78c1ba4.svg";